import { createAppTestIds } from './index';

/**
 * Test IDs for Gmail integration
 */
export const GMAIL_TEST_IDS = {
  ...createAppTestIds('gmail'),
} as const;
